import { Button } from 'components';
import React from 'react';
import PropTypes from 'prop-types';
const ActionButtons = ({ onPrev, isLoading = false, isUSerExist }) => {
  return (
    <div className="md:w-1/2 w-full flex justify-end">
      <Button
        text="Geri"
        className="bg-ink p-3 mx-auto w-1/3"
        textVariant="white"
        onClick={onPrev}
      />
      <Button
        type="submit"
        text={isUSerExist ? 'Tamamla' : 'İlerle'}
        className="bg-primary p-3 mx-auto w-2/3"
        textVariant="white"
        disabled={isLoading}
      />
    </div>
  );
};

export default ActionButtons;

ActionButtons.propTypes = {
  onPrev: PropTypes.func,
  isLoading: PropTypes.bool,
  isUSerExist: PropTypes.bool,
};
